import React,{useState} from 'react'
import Header from '../../components/Header';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from "react-router-dom";
import { ArrowLongLeftIcon } from '@heroicons/react/24/outline';
import { Card } from 'primereact/card';
import EmployeeRightBar from './EmployeeRightBar';

const HandBookEmployeeList = () => {
 
  const [value, setValue] = useState(false);

  const onOpen =()=>{
   setValue(true);
  }
  return (
    <>
    <Header />
    <div className="mx-auto max-w-7xl  px-4 sm:px-6 lg:px-8">
    <div className="lg:flex lg:items-center pt-5 lg:justify-between">
      <div className="min-w-0 flex-1">
        <h6 className="flex items-center text-1xl font-bold leading-7 text-gray-900 sm:truncate  sm:tracking-tight">
         <ArrowLongLeftIcon className="h-6 w-6 me-1" aria-hidden="true" /> Return to Home
        </h6>
      </div>
    </div>
    <div className='py-4'>
    <div className="flex justify-end w-full mb-2 items-center">
        <span className="p-input-icon-left">
           <i className="pi pi-search" />
            <InputText value=""  placeholder="Search" className="h-10" style={{width:"320px"}} />
         </span>
         <Link to='/' className="ms-2 inline-flex items-center rounded-md bg-sky-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
              Create New
          </Link>
      </div>
      <Card className='table_call'>
         <div className='flex justify-between px-4 pb-3 items-center '>
            <div>
               <h6 className='text-1xl font-bold text-gray-900'>Employees</h6>
            </div>
          </div>
      <DataTable rows={10} className="custpaginator custIcons custmBtnTable custTable" scrollable paginator responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" 
                                    value={[
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link onClick={()=>onOpen()} className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },
                                      {
                                        Role: 'Employee',
                                        FirstName: '9807',
                                        employeeId: 'Olivia',
                                        LastName: 'Kyrylenko',
                                        Email: 'olivia@edbrix',
                                        Department: 'Physics',
                                        Manager: 'Natalia',
                                        DateOfJoining: '10/04/2022',
                                        action: <Link to='' className="py-2 px-2.5" ><i className="gusd-edit text-[#667085] text-[16px] font-meduim"></i> Edit</Link>
                                      },

                                    ]}>
                                    <Column field="Role" sortable header="Role"></Column>
                                    <Column field="employeeId" sortable header="Employee Id"></Column>
                                    <Column field="FirstName" sortable header="First Name"></Column>
                                    <Column field="LastName" sortable header="Last Name"></Column>
                                    <Column field="Email" sortable header="Email"></Column>
                                    <Column field="Department" sortable header="Department"></Column>
                                    <Column field="Manager" sortable header="Manager"></Column>
                                    <Column field="DateOfJoining" sortable header="Date of joining"></Column>
                                    <Column field="action" sortable header="Action" className='text-right'></Column>
                                  </DataTable>
                                  </Card>
              <EmployeeRightBar value={value} />
    </div>
    </div>
    </>
  )
}

export default HandBookEmployeeList;